// libs
import React from 'react';

import { stopEventPropagation } from '@lyearn/core/utils/events';
import { Box } from '@lyearn/ui';
import { useGenerativeTaskContext } from '@/components/LyearnAI/context/generativeTaskContext';
import AIFeedback from '@/features/ai-feedback';

import { useAIEditorContext } from '../../../context/AIEditorContext';

const AIEditorFeedback: React.FC = () => {
  const { isDone, generativeTaskId } = useGenerativeTaskContext();
  const { suggestedText } = useAIEditorContext();

  if (!generativeTaskId || !suggestedText || !isDone) {
    return null;
  }

  return (
    <Box className="w-auto px-16 py-12" onClick={stopEventPropagation}>
      <AIFeedback entityId={generativeTaskId} />
    </Box>
  );
};

export default AIEditorFeedback;
